import React from "react";
import { Collapsible } from "../../collapsible";
import { BlockField } from "../";
export var BlockCollapsible = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { style: { marginBottom: "30px" } },
        React.createElement(Collapsible, { openTitle: "Read more", closeTitle: "Read less", buttonSize: "large", splitIndex: 0 }, children.map(function (block) { return (React.createElement(BlockField, { key: block.id, block: block })); }))));
};
